<template>
  <b-col sm="12" :lg="lgSize">
    <b-card class="state" header="Received">
      <DateModal
        modalID="region_overview"
        :fetchData="fetchStateReport"
        :dateFrom="stateDateFrom"
        :dateTo="stateDateTo"
        @date-picker-modal-emit="onDatePickerModalEmit"
      ></DateModal>
      <div
        slot="header"
        style="display:flex; justify-content: space-between; align-items: center;"
      >
        <div style="display: flex; justify-content: flex-start; align-items: left;">
          <HeaderTitle
            title="Region Overview"
            :dateFrom="from() ? from() : stateDateFrom"
            :dateTo="to() ? to() : stateDateTo"
          ></HeaderTitle>
        </div>
          <HeaderControl
            :showFullscreenIcon="true"
            :showDateIcon="true"
            @emit-fullscreen="toggleFullScreen"
            @emit-date="modalDateEvent('region_overview')"
            @emit-last-month="setLastMonth"
          ></HeaderControl>
      </div>
      <div
        style="width: 100%; display: flex; justify-content: flex-end; margin-top: 0px"
      >
        <h5>Received</h5>
          <c-switch
            class="mx-1"
            color="primary"
            v-model="isReceived"
            variant="pill"
            :checked="false"
            @change="toggleReportType"
          />
        <h5>Shipped</h5>
      </div>
      <div class="chart-wrapper">
        <div v-if="loadingState" class="centered_container">
          <LoadingCard></LoadingCard>
        </div>
        <div style="height: 280px; padding-top: 150px" v-if="loadingState" class="loading"></div>
        <div v-else>
          <highmaps
            style="height: 100%"
            ref="stateRef"
            :options="optionsMap"
          ></highmaps>
        </div>
      </div>
      <Modal
        size="lg"
        :title="selectedStateName"
        class="modal-primary cities"
        @on-ok="fetchChartStateDetails()"
        v-model="stateChartModal"
        :transfer="false"
      >
        <div class="checkbox" style="float: right">
          <label>
            <input
              v-model="selectAll"
              type="checkbox"
              :checked="true"
              class="form-check-input"
              name="foo"
            />
            Select All
          </label>
        </div>
        <br />
        <div class="modal-body">
          <div class="chart-wrapper">
            <LoadingCard v-if="StateChartDetails"></LoadingCard>
            <div v-else class="row">
              <br />
            </div>
          </div>
          <br />
        </div>
      </Modal>
    </b-card>
  </b-col>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import Highcharts from "highcharts-vue";
import iView from "iview";
import Datepicker from "vuejs-datepicker";
import router from "../../router";
import usAll from "../../views/base/usAll";
import DateModal from "../shared/DateModal.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import LoadingCard from "../shared/LoadingCard.vue";
import { modelStore, setIsFetching  } from '@/stores/modelStore';

export default {
  name: "RegionOverview",
  components: {
    router,
    Highcharts,
    usAll,
    Datepicker,
    iView,
    cSwitch,
    LoadingCard,
    DateModal,
    HeaderTitle,
    HeaderControl
  },
  props: ["lgSize"],
  data: function() {
    return {
      selectedStateName: "",
      selected: "All",
      value: [20, 50],
      selectedCompany: "All",
      loadingState: false,
      valueQuantity: false,
      visible: false,
      selectAll: true,
      stateChartModal: false,
      stateDateFrom: "",
      stateDateTo: "",
      checkData: [],
      modalData: [],
      stateModal: false,
      fullscreenState: false,
      StateChartDetails: false,
      selectedModalLocations: [],
      reportType: "received",
      reportTypeOptions: [
        { name: "Received", item: "received" },
        { name: "Shipped", item: "shipped" }
      ],
      optionsMap: {
        tooltip: {
          formatter: function() {
            return this.point.name + ": " + this.point.sign;
          }
        },
        chart: {
          map: usAll,
          backgroundColor: "transparent"
        },
        title: {
          text: ""
        },
        plotOptions: {
          map: {
            states: {
              hover: {
                color: "#EEDD66"
              }
            }
          },
          series: {
            stacking: "normal",
            point: {
              events: {
                click: ({ point }) => {
                  this.$refs.stateRef.chart.reflow();
                  this.selectedState = point.code;
                  router.push(
                    "/base/MapByState/?state=" +
                      point.code +
                      "&date_from=" +
                      this.stateDateFrom +
                      "&date_to=" +
                      this.stateDateTo +
                      "&locations=" +
                      this.selectedModalLocations +
                      "&type=" +
                      this.reportType +
                      (this.selected === "All" ? "" : "&productType=" + this.selected)
                  );
                }
              }
            }
          }
        },
        subtitle: {
          text: ""
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "bottom"
          }
        },
        colorAxis: {
          min: 0
        },
        series: [
          {
            mapData: usAll,
            data: this.data,
            joinBy: ["postal-code", "code"],
            name: "USA",
            color: "blue",
            states: {
              hover: {
                color: "#BADA55"
              }
            },
            dataLabels: {
              enabled: true,
              format: "{point.name}"
            }
          }
        ]
      }
    };
  },
  computed: {
    selectedModel() {
      return modelStore.selectedModel;
    },
    flagChanged() {
      return modelStore.isSpaced;
    },
    isReceived: {
      get() {
        return this.reportType !== "received";
      },
      set(value) {
        this.reportType = value ? "shipped" : "received";
        this.fetchStateReport();
      }
    }
  },
  watch: {
    selectedModel() {
      this.fetchStateReport();
    },
    flagChanged() {
      this.fetchStateReport();
    },
    selectAll(value) {
      if (!value) {
        this.selectedModalLocations = [];
      } else {
        this.modalData.forEach(value => {
          this.selectedModalLocations.push(value.id);
        });
      }
    },
    receivedLocation() {
      // alert(value)
    },
    valueQuantity() {
      this.fetchStateReport();
      if (this.fullscreenState) {
        this.$refs.stateRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.stateRef.chart.options.chart.height = 400;
      }
    }
  },
  methods: {
    toggleReportType() {
      this.reportType = this.isReceived ? "shipped" : "received";
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".state"), {
        wrap: false,
        callback: this.fullscreenChangeState
      });
    },
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.stateDateFrom = changedDateFrom;
      this.stateDateTo = changedDateTo;
    },
    modalDateEvent(modal_id) {
      this.$bvModal.show(modal_id);
    },
    setLastMonth() {
      let fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 30);

      this.stateDateFrom = fromDate.toJSON().slice(0, 10);
      this.stateDateTo = new Date().toJSON().slice(0, 10);

      this.fetchStateReport();
    },
    from() {
      if (typeof this.stateDateFrom === "object") {
        this.stateDateFrom = this.stateDateFrom.toISOString().split("T")[0];
        return this.stateDateFrom;
      }
      return this.stateDateFrom;
    },
    to() {
      if (typeof this.stateDateTo === "object") {
        this.stateDateTo = this.stateDateTo.toISOString().split("T")[0];
        return this.stateDateTo;
      }
      return this.stateDateTo;
    },
    show() {
      this.visible = true;
    },
    fetchStateReport() {
      setIsFetching(true);
      this.loadingState = true;
      let params = {};

      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;

      params = {
        date_from: this.stateDateFrom,
        date_to: this.stateDateTo,
        value: this.valueQuantity,
        company: this.selectedCompany,
        type: this.reportType,
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {}),
      };

      if (this.stateDateFrom === "" && this.stateDateTo === "") return;

      this.$http.get("api/comcast_arc/maps/stateReport.php", { params }).then(
        res => {
          this.data = res.data.records;
          this.data1 = this.data;
          this.optionsMap.series[0].data = this.data1;
          setIsFetching(false);
          this.loadingState = false;
          setTimeout(() => {
            if (this.fullscreenState) {
              this.$refs.stateRef.chart.options.chart.height = "50%";
            } else {
              this.$refs.stateRef.chart.options.chart.height = 400;
            }
            this.$refs.stateRef.chart.reflow();
          });
        },
        err => {
          console.log(err);
          setIsFetching(false);
          this.loadingState = false;
        }
      );
    },
    fetchChartStateDetails() {
      if (this.selectedModalProductGroup === "All product groups") {
        this.selectedModalProductGroup = "";
      }
      if (typeof this.stateDateFrom === "object") {
        this.stateDateFrom = this.stateDateFrom.toISOString().split("T")[0];
      }
      if (typeof this.stateDateTo === "object") {
        this.stateDateTo = this.stateDateTo.toISOString().split("T")[0];
      }
      if (this.selectedModalLocations.length < 1) {
        alert("You must select at least one location ! ");
      } else {
        router.push(
          "/base/MapByState/?state=" +
            this.selectedState +
            "&date_from=" +
            this.stateDateFrom +
            "&date_to=" +
            this.stateDateTo +
            "&locations=" +
            this.selectedModalLocations +
            "&type=" +
            this.reportType +
            (this.selected === "All" ? "" : "&productType=" + this.selected)
        );
      }
    },
    fullscreenChangeState(fullscreenState) {
      this.fullscreenState = fullscreenState;
      if (this.fullscreenState) {
        this.$refs.stateRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.stateRef.chart.options.chart.height = 400;
      }
      this.$refs.stateRef.chart.reflow();
    }
  },
  mounted() {
    if (!localStorage.getItem("arr_user")) {
      router.push("/pages/login/");
    }
    this.locationsIds = localStorage.getItem("locations");

    this.valueQuantity = false;

    let fromDate = new Date(Date.UTC(2024, 9, 1));

    this.stateDateFrom = fromDate.toJSON().slice(0, 10);
    this.stateDateTo = new Date().toJSON().slice(0, 10);
    this.fetchStateReport();
  }
};
</script>
<style>
.ivu-modal-content {
  background: #3a4149 !important;
}
.cities .ivu-modal {
  width: 660px !important;
}
.ivu-modal-header p,
.ivu-modal-header-inner {
  color: white !important;
  font-size: 1.09375rem;
  font-weight: 500;
}
.ivu-modal-header {
  border-bottom: 1px solid #23282c !important;
  padding: 1rem;
}
.ivu-btn-text {
  color: #23282c;
  background-color: #acb5bc;
  border-color: #a5aeb7;
}
.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.btn-group-region {
  display: inline-flex;
  overflow: hidden;
  border-radius: 0px;
}

.btn-group-region .btn {
  padding: 1px 10px;
  font-size: 13px;
  height: 25px;
  padding-bottom: 10px;
  border-radius: 0;
  box-shadow: none;
}

.btn-group-region .btn:first-child {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.btn-group-region .btn:last-child {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.btn-group-region .btn-sm {
  padding: 1px 8px;
}

.btn-group-region {
  padding-left: 10px;
}
</style>
